import React, { useEffect, useState } from 'react';
import {
  FOOTER_LINK_1,
  FOOTER_LINK_2,
  FOOTER_LINK_3,
  COPYWRIGHT_TEXT,
} from '../../constants/constant';
import '../Styles/globals.css';
import '../Styles/muiglobal.css';
import commonService from 'src/services/commonService';

interface ProjectVersionResponse {
  version: string;
}

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [PROJECT_VERSION, setProjectVersion] = useState<string>('');

  useEffect(() => {
    const ele: HTMLElement | null = document.getElementById('twilio-iframe-container');
    if (ele) ele.style.visibility = 'hidden';
    const eleBtn: HTMLElement | null = document.getElementById('twilio-iframe-button');
    if (eleBtn) eleBtn.style.visibility = 'hidden';

    //   const fetchProjectVersion = async (): Promise<void> => {
    //     try {
    //       setProjectVersion('Version: 1.0.0');
    //     } catch (error) {
    //       console.error('Error', error);
    //     }
    //   };

    //   void fetchProjectVersion();
    // }, []);
    commonService.getProjectVersion()
      .then((res: { data: ProjectVersionResponse }) => {
        setProjectVersion(`Version: ${res.data.version}`);
      })
      .catch(error => {
        console.error("Error fetching project version:", error);
      });
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col auth-layout">
      <div className="relative flex flex-grow max-[480px]:p-3 form-container">
        <div className="container max-w-[370px] mx-auto pt-[80px] flex flex-col z-10">
          <div className="login-header">
            <img
              src='/assets/images/FooterLogo.png'
              alt='logo'
              width={160}
              height={30}
              className='mx-auto mb-[50px]'
            />
          </div>
          {children}
        </div>
        <img
          src='/assets/images/connectionDots.png'
          alt='decorative dots'
          className='decorative-image'
        />
      </div>
      <div className='w-full flex flex-col sm:flex-row justify-between items-center px-[50px] pt-[20px] pb-[20px] mt-auto'>
        <div className='flex justify-start sm:justify-center items-center mb-[10px] sm:mb-0'>
          <p className='text-muted2 text-12'>{COPYWRIGHT_TEXT}</p>
        </div>
        <div className='flex justify-center items-center mb-[10px] sm:mb-0'>
          <p className='text-muted2 text-12 sm:ml-[-20px]'>{PROJECT_VERSION}</p>
        </div>
        <div>
          <a
            href='https://www.healthlinkdimensions.com/website-terms'
            target='_blank'
            rel='noopener noreferrer'
            className='text-muted2 text-12 hover:text-primary pr-4 border-r border-muted2 pt-0 pb-0'
          >
            {FOOTER_LINK_1}
          </a>
          <a
            href='https://www.healthlinkdimensions.com/privacy-policy'
            target='_blank'
            rel='noopener noreferrer'
            className='text-muted2 text-12 hover:text-primary pr-4 pl-4 border-r border-muted2 pt-0 pb-0'
          >
            {FOOTER_LINK_2}
          </a>
          <a
            href='https://www.healthlinkdimensions.com/consumerprivacyrights'
            target='_blank'
            rel='noopener noreferrer'
            className='text-muted2 text-12 hover:text-primary pl-4'
          >
            {FOOTER_LINK_3}
          </a>
        </div>
      </div>
      <div style={{ display: 'none' }}>{'v.4.0'}</div>
    </div>
  );
};

export default AuthLayout;
